import React from 'react';
import { InfoIcon, MessagesSquareIcon } from 'lucide-react';
import { followUpExamples } from '../../data/content';
export function FollowUp() {
  return <section aria-labelledby="seguimiento-title" className="w-full bg-ink-800" data-id="element-53" data-mp="cen67ohboohk">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center md:py-24" data-id="element-54" data-mp="hc56yrl6rxeh">
        <MessagesSquareIcon className="mx-auto h-8 w-8 text-brand-green" aria-hidden="true" data-id="element-55" data-mp="lc79t42nqwvc" />
        <h2 id="seguimiento-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-[2.5rem]" data-id="element-56" data-mp="3kt5cbknpdtyj">
          El contacto no termina con la videollamada
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-body" data-id="element-57" data-mp="3trh9k5j2rpzy">
          Si posteriormente aparece una situación concreta relacionada con la carrera del
          futbolista, pueden volver a escribirnos para recibir orientación sobre ese caso
          específico.
        </p>

        <p className="mt-10 text-sm font-bold text-white" data-id="element-58" data-mp="362eik72jwkss">Por ejemplo, si aparece:</p>
        <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-59" data-mp="165fwglu01he8">
          {followUpExamples.map(example => <li key={example} className="rounded-full border border-ink-border bg-ink-card px-4 py-2 text-[15px] text-body" data-id="element-60" data-mp="1174qwnaqlt1t">
              {example}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-xl items-start justify-center gap-2.5 text-sm leading-relaxed text-subtle" data-id="element-61" data-mp="re5zkxnuvoei">
          <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-62" data-mp="iflmcc12e6xo" />
          <span data-id="element-63" data-mp="ihon9r3r9kh6">
            Se trata de orientación sobre situaciones concretas que puedan surgir. No implica
            representación permanente ni acompañamiento ilimitado.
          </span>
        </p>
      </div>
    </section>;
}